import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import { BaseRouting } from '@aipb/gulliver/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogRouting extends BaseRouting {
  static configPath = ':configId';
  static searchPath = 'search';
  static topicSinglePath = 'single/:id';
  static topicPath = 'topic';
  static searchDefaultPath = '';
  static searchResultPath = 'result';
  static searchMapPath = 'map';
  static detailPath = 'detail';
  static settingsPath = 'settings';
  static newsPath = 'news';
  static detailDefaultPath = '';
  static detailSinglePath = 'single/:id';
  static comparePath = 'compare';
  static compareDefaultPath = ':id1/:id2';
  static APP_ROUTE = 'catalog';

  private _detailDefault: string[] = [CatalogRouting.detailPath];
  private _detailSingle: string[] = [CatalogRouting.detailPath, CatalogRouting.detailSinglePath];
  private _searchDefault: string[] = [CatalogRouting.searchPath];
  private _searchResult: string[] = [CatalogRouting.searchPath, CatalogRouting.searchResultPath];
  private _searchMap: string[] = [CatalogRouting.searchPath, CatalogRouting.searchMapPath];
  private _settingsDefault: string[] = [CatalogRouting.settingsPath];
  private _newsDefault: string[] = [CatalogRouting.newsPath];
  private _topicSingle: string[] = [CatalogRouting.topicPath, CatalogRouting.topicSinglePath];
  private _compareDefault: string[] = [CatalogRouting.comparePath, CatalogRouting.compareDefaultPath];

  constructor(catalogEnv: CatalogEnvService) {
    super(['/' + CatalogRouting.APP_ROUTE, CatalogRouting.configPath], catalogEnv);
  }

  public compareDefault(id1: string, id2: string, configId: string = this.getConfigId()): void {
    this.nav(this._compareDefault, {
      configId,
      id1,
      id2
    });
  }

  public compareDefaultAbsUrl(id1: string, id2: string, configId: string = this.getConfigId()): string {
    return this.absUrl(this._compareDefault, {
      configId,
      id1,
      id2
    });
  }

  public compareDefaultRouteUrl(id1: string, id2: string, configId: string = this.getConfigId()): string {
    return this.routeUrl(this._compareDefault, {
      configId,
      id1,
      id2
    });
  }

  public searchDefault(configId: string = this.getConfigId()): void {
    this.nav(this._searchDefault, {
      configId
    });
  }

  public searchDefaultAbsUrl(configId: string = this.getConfigId()): string {
    return this.absUrl(this._searchDefault, {
      configId
    });
  }

  public searchDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._searchDefault, {
      configId
    });
  }

  public searchResult(configId: string = this.getConfigId()): void {
    this.nav(this._searchResult, {
      configId
    });
  }

  public searchResultUrl(configId: string = this.getConfigId()): string {
    return this.absUrl(this._searchResult, {
      configId
    });
  }

  public searchResultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._searchResult, {
      configId
    });
  }

  public searchMap(configId = 'default'): void {
    this.nav(this._searchMap, {
      configId
    });
  }

  public searchMapAbsUrl(configId: string = this.getConfigId()): string {
    return this.absUrl(this._searchMap, {
      configId
    });
  }

  public searchMapRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._searchMap, {
      configId
    });
  }

  public detailDefault(configId: string = this.getConfigId()): void {
    this.nav(this._detailDefault, {
      configId
    });
  }

  public detailDefaultAbsUrl(configId: string = this.getConfigId()): string {
    return this.absUrl(this._detailDefault, {
      configId
    });
  }

  public settingsDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._settingsDefault, {
      configId
    });
  }

  public newsDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._newsDefault, {
      configId
    });
  }

  public detailDefaultRouteUrl(configId: string = this.getConfigId()): string {
    return this.routeUrl(this._detailDefault, {
      configId
    });
  }

  public detailSingle(id: string, configId: string = this.getConfigId()): void {
    this.nav(this._detailSingle, {
      id,
      configId
    });
  }

  public detailSingleAbsUrl(id: string, configId: string = this.getConfigId()): string {
    return this.absUrl(this._detailSingle, {
      id,
      configId
    });
  }

  public detailSingleRouteUrl(id: string, configId: string = this.getConfigId()): string {
    return this.routeUrl(this._detailSingle, {
      id,
      configId
    });
  }

  public topicSingle(id: string, configId: string = this.getConfigId()): void {
    this.nav(this._topicSingle, {
      id,
      configId
    });
  }

  public topicSingleRouteUrl(id: string, configId: string = this.getConfigId()): string {
    return this.routeUrl(this._topicSingle, {
      id,
      configId
    });
  }
}
